/** Really, any attributes will be carried accros */
export class GridRowAttributes{
}